/**
 * @license
 * Copyright 2020 Google Inc.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @internal
 */
export const PUPPETEER_REVISIONS = Object.freeze({
  chrome: '123.0.6312.122',
  'chrome-headless-shell': '123.0.6312.122',
  firefox: 'latest',
});
